export function register (state) {
    return state.register;
}
